module.exports = __webpack_public_path__ + "img/34.2007e97c.jpg";